var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20758 2.13458C8.45758 1.36708 9.54341 1.36708 9.79258 2.13458L11.0584 6.02959C11.1129 6.19666 11.2188 6.34223 11.361 6.44551C11.5032 6.54878 11.6743 6.60446 11.8501 6.60459H15.9459C16.7534 6.60459 17.0884 7.63792 16.4359 8.11292L13.1226 10.5196C12.9803 10.6231 12.8743 10.7689 12.82 10.9363C12.7656 11.1036 12.7657 11.2839 12.8201 11.4513L14.0851 15.3463C14.3351 16.1146 13.4559 16.7529 12.8034 16.2779L9.49008 13.8713C9.34767 13.7677 9.17614 13.712 9.00008 13.712C8.82402 13.712 8.65249 13.7677 8.51008 13.8713L5.19675 16.2779C4.54425 16.7529 3.66508 16.1138 3.91508 15.3463L5.18008 11.4513C5.23448 11.2839 5.23451 11.1036 5.18017 10.9363C5.12583 10.7689 5.01991 10.6231 4.87758 10.5196L1.56425 8.11292C0.910913 7.63792 1.24758 6.60459 2.05425 6.60459H6.14925C6.32512 6.60463 6.4965 6.54903 6.63885 6.44575C6.7812 6.34247 6.88723 6.19679 6.94175 6.02959L8.20758 2.13458Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-outline.a4fb4778870b4bc5681179bef573d223.svg";